export function createRoutes() {
  return [
    {
      path: 'programs',
      component: () => import(/* webpackChunkName: "ProgramChrome" */ './ProgramChrome.vue'),
      children: [
        {
          path: '/',
          name: 'programList',
          component: () => import(/* webpackChunkName: "ProgramList" */ './ProgramList.vue'),
        },
        {
          path: 'import',
          name: 'dialog',
          components: {
            default: () => import(/* webpackChunkName: "ProgramList" */ './ProgramList.vue'),
            dialog: () => import(/* webpackChunkName: "ImportProgramContentModal" */ './ImportProgramContentModal.vue'),
          },
        },
        {
          path: 'create',
          name: 'programAdd',
          component: () => import(/* webpackChunkName: "ProgramAdd" */ './ProgramAdd.vue'),
        },
        {
          path: ':programKey',
          name: 'programEdit',
          component: () => import(/* webpackChunkName: "ProgramEdit" */ './ProgramEdit.vue'),
        },
      ],
    },
  ];
}

export default {
  createRoutes,
};
